/* Refresh the separate description only when Flow switches to a different product URL.
   Regular variant selection does not fetch or replace forms, stock or pricing. */
(function(){
 'use strict';
 if(window.__rrProductDetailsV3)return;
 let serial=0,controller;
 const preview=new URL(location.href).searchParams.get('preview_theme_id');
 function path(value){try{return new URL(value,location.origin).pathname;}catch(_){return '';}}
 async function sync(context){
  const panel=document.getElementById('rr-product-details');
  if(!panel)return;
  const main=panel.querySelector('.rrp-details__main');
  if(!main||!panel.dataset.sectionId)return;
  const product=document.querySelector('[id$="__product-form"] product-information');
  if(context?.sectionId&&product?.dataset.sectionId&&context.sectionId!==product.dataset.sectionId)return;
  const current=location.pathname;
  if(!/\/products\/[^/]+\/?$/.test(current))return;
  const crumb=document.querySelector('.rrp-nav__crumbs [aria-current]'),title=product?.querySelector('h1');
  if(crumb&&title)crumb.textContent=title.textContent;
  const id=++serial;controller?.abort();main.removeAttribute('aria-busy');
  if(current===path(panel.dataset.productPath))return;
  const requestController=controller=new AbortController();main.setAttribute('aria-busy','true');
  const url=new URL(location.href);url.searchParams.set('section_id',panel.dataset.sectionId);
  if(preview)url.searchParams.set('preview_theme_id',preview);
  const timer=setTimeout(()=>requestController.abort(),15000);
  try{
   const response=await fetch(url,{credentials:'same-origin',signal:requestController.signal});
   if(!response.ok)throw new Error('Description unavailable');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');
   const replacement=doc.getElementById('rr-product-details'),updated=replacement?.querySelector('.rrp-details__main');
   if(!replacement||!updated||path(replacement.dataset.productPath)!==current)throw new Error('Wrong product response');
   if(id!==serial||!panel.isConnected)return;
   main.replaceChildren(...updated.childNodes);panel.dataset.productPath=current;
  }catch(error){
   if(id!==serial||!panel.isConnected)return;
   main.replaceChildren();const message=document.createElement('p');message.textContent='Refresh this product page to see its full details.';
   const link=document.createElement('a');link.href=location.href;link.textContent='Refresh product details';main.append(message,link);
  }finally{clearTimeout(timer);if(id===serial)main.removeAttribute('aria-busy');}
 }
 window.__rrProductDetailsV3={sync};
 const start=()=>{if(window.eventBus)window.eventBus.on('variant:updated',sync);};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 window.addEventListener('popstate',()=>sync());
})();
